<template lang="html">

  <nav class="migas row-start" :style="style.colorWhite">
    <router-link to="/" v-if="!!!inicioPersonalizado">Inicio</router-link>
    <router-link :to="inicioPersonalizado" v-else>Inicio</router-link>
    <template v-if="!inOferta">
      <router-link :to="view">{{$t(`encabezado.${$route.meta.name}`)}}</router-link>
    </template>
    <template v-else>
        <router-link to="/mis-ofertas">{{$t(`encabezado.mis_ofertas`)}}</router-link>
    </template>
    <router-link v-if="!!last" class="last" :to="$route.fullPath">{{last}}</router-link>
  </nav>

</template>

<script lang="js">

  import {mapGetters} from 'vuex';

  export default  {
    name: 'migas',
    props : ['last','inicioPersonalizado'],
    computed : {
      ...mapGetters({
        style : 'getStyles'
      }),
      view : function(){
        let url = this.$route.path.split("/");
        url = url.pop();
        url = '/'+url;
        return url;
      },
      inOferta : function(){
        return (this.$route.fullPath.includes("/oferta/"));
      }
    }
  }
</script>

<style scoped lang="scss">

@import '@/assets/css/colors.scss';

.migas a{
  font-size: 14px;
  line-height: 20px;
}

.migas a{
  color: currentColor;
}

.migas a::after{
  content: '>';
  padding-right: 5px;
  margin-left: 5px;
  display: inline-block;
  font-size: 16px;
  line-height: 20px;
}

.migas a:last-of-type::after{
  display: none;
}

.migas-ficha .migas{
  padding-top: 10px;
}

@media screen and (max-width: 700px){
  .migas .last{
    display: none;
  }

  .migas a:nth-child(2)::after{
    display: none;
  }
}



</style>



// WEBPACK FOOTER //
// src/components/parts/migas.vue